import { useApiQuery } from '@BUP/hooks/useApiQuery'

/**
 * The counselor's period history for the current term, newest first, each with its completion
 * count - where a closed period can be found and reopened. Pass a grade to narrow it to that
 * grade's periods; omit it to list every grade.
 */
export const useGetPeriods = (grade) => {
  const query = useApiQuery(
    ['courseAssignmentPeriods', grade ?? null],
    'schools',
    client => client.get('/current-organization/course-assignment/periods', { params: grade ? { grade } : {} }),
    {},
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    periods: query.data?.periods ?? [],
    error: query.error,
    refetch: query.refetch
  }
}
